
import { DashboardLayout } from "@/components/dashboard/DashboardLayout";
import { DashboardContent } from "@/components/dashboard/DashboardContent";
import { DashboardLoading } from "@/components/dashboard/DashboardLoading";
import { NoProfileView } from "@/components/dashboard/NoProfileView";
import { useDashboardData } from "@/hooks/useDashboardData";

export default function Index() {
  const {
    isLoading,
    profile,
    coachClients,
    timeFrame,
    handleTimeFrameChange
  } = useDashboardData();

  if (isLoading) {
    return <DashboardLoading />;
  }

  if (!profile) {
    return <NoProfileView />;
  }

  return (
    <DashboardLayout 
      avatar={profile.avatar_url && profile.avatar_url !== "/placeholder.svg" ? profile.avatar_url : null} 
      name={profile.full_name || 'Anonymous'}
    >
      <DashboardContent 
        profile={profile}
        coachClients={coachClients}
        timeFrame={timeFrame}
        onTimeFrameChange={handleTimeFrameChange}
      />
    </DashboardLayout>
  );
}
